<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g id="Icons-/-Checkmark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g transform="translate(0.000000, 5.000000)">
      <polygon id="Path" [attr.fill]="color" points="15.1402544 33.7104331 44 4.85058464 39.1494497 0 15.1402544 24.0092295 4.85058464 13.7195597 0 18.5701444"></polygon>
    </g>
  </g>
</svg>
